import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import {colors} from '../../../../styles/variables';

interface Props {
  children?: React.ReactNode;
}

const ListItemRightSeparator: React.FunctionComponent<Props> = props => {
  return <View style={styles.separator} />;
};

export default React.memo(ListItemRightSeparator);

const styles = StyleSheet.create({
  separator: {
    backgroundColor: colors.powderGray,
    height: StyleSheet.hairlineWidth,
    marginLeft: 10,
  } as ViewStyle,
});
